module.exports = __webpack_public_path__ + "img/24-min.9aa8538b.jpg";